import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PrivacyPolicyComponent } from './page/privacy-policy/privacy-policy.component';
import { SecurityComponent } from './page/security/security.component';
import { ServiceManagementComponent } from './page/service-management/service-management.component';

const routes: Routes = [
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent
  },
  {
    path: 'security',
    component: SecurityComponent
  },
  {
    path: 'service-management',
    component: ServiceManagementComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FooterPagesRoutingModule { }
